import { useAppSelector } from "app/hooks";
import { selectCurrentUser } from "features/auth/auth-slice";
import { VoiceCalendarBusy } from "services/types/users.type";

import { useDialstackSoftphone } from "./use-dialstack-softphone.hook";

export type SoftphoneBusySignals = {
  /** What the user's Suno calendar says they are doing right now. */
  calendarBusy: VoiceCalendarBusy;
  /** The user asked for a busy calendar to turn Do Not Disturb on as well. */
  calendarSilencesCalls: boolean;
  /** A scribe session is live in this browser — this tab or another. */
  isRecording: boolean;
};

/**
 * What Suno knows about the user beyond their phone (ENG-2022). The backend
 * keeps `voice_calendar_busy` current and pushes changes over the
 * notifications socket. The recording flag is the one the phone already
 * declines calls on (ENG-2001), so the dot and the phone always agree — a
 * paused recording counts, and so does one in another tab.
 */
export default function useSoftphoneBusySignals(): SoftphoneBusySignals {
  const currentUser = useAppSelector(selectCurrentUser);
  const { scribeRecordingActive } = useDialstackSoftphone();
  const calendarBusy = currentUser?.voice_calendar_busy || "";
  return {
    calendarBusy,
    calendarSilencesCalls:
      Boolean(calendarBusy) && Boolean(currentUser?.voice_busy_silences_calls),
    isRecording: scribeRecordingActive
  };
}
